<template>
  <div class="container" :style="cssVars" id="rootchart">
    <el-tabs tab-position="top" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="概览" name="first">
        <Overviews ref="overviews" />
      </el-tab-pane>
      <el-tab-pane label="资产列表" name="second">
        <Property ref="property" />
      </el-tab-pane>
      <el-tab-pane label="运营数据" name="third">
        <OperationOverviews ref="OperationOverviews" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Overviews from './Overviews.vue';
import Property from './Property.vue';
// import Operation from "./Operation.vue";
import OperationOverviews from './OperationOverviews.vue';
export default {
  components: {
    Overviews,
    Property,
    OperationOverviews,
  },
  computed: {},
  created() {
    let name = localStorage.getItem('activeName');
    this.handleClick({ name: name });
  },
  mounted() {
    this.fnGetWidth();
    window.addEventListener('resize', this.funResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.funResize);
  },
  data() {
    return {
      sCurrentTheme: this.$store.state.theme == 'dark' ? true : false,
      ROOTFONTFIZE: 0,
    };
  },
  methods: {
    async handleClick(e) {
      this.activeName = e.name;
      localStorage.setItem('activeName', this.activeName);
      let activeName = e.name;
      // console.log('handleClick', activeName);

      if (activeName == 'first') {
        this.$eventBus.$emit('setBreadcrumbs', '概览');
        setTimeout(() => {
          this.$refs.overviews.handleClick(e);
        }, 200);
      }
      if (activeName == 'second') {
        this.$eventBus.$emit('setBreadcrumbs', '资产列表');
        setTimeout(() => {
          this.$refs.property.handleClick(e);
        }, 200);
      }
      if (activeName == 'third') {
        this.$eventBus.$emit('setBreadcrumbs', '运营数据');
        setTimeout(() => {
          this.$refs.OperationOverviews.handleClick(e);
        }, 200);
      }
    },

    fnGetTheme() {
      this.sCurrentTheme = this.$store.state.theme == 'dark' ? true : false;
    },
    fnGetWidth() {
      var element = document.getElementById('rootchart');
      let ROOTFONTFIZE = element.offsetWidth;
      ROOTFONTFIZE = ROOTFONTFIZE > 1440 ? 1440 : ROOTFONTFIZE;
      ROOTFONTFIZE = ROOTFONTFIZE < 1400 ? ROOTFONTFIZE - 200 : ROOTFONTFIZE;
      this.ROOTFONTFIZE = ROOTFONTFIZE / 10;

      window.sessionStorage.setItem('ROOTFONTFIZE', this.ROOTFONTFIZE);
    },

    funResize() {},
  },
  computed: {
    cssVars() {
      return {
        '--ROOTFONTFIZE': this.ROOTFONTFIZE + 'px',
      };
    },
    currentTheme() {
      return this.$store.state.theme; // 从Vuex中获取当前的主题值
    },
  },
  watch: {
    currentTheme(newVal, oldVal) {
      this.fnGetTheme();
    },
  },
};
</script>

<style scoped>
.container {
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
  font-weight: 400;
  width: 100% !important;
  box-sizing: border-box !important;
  padding: 0 !important;
  padding-right: 20px !important;
  letter-spacing: 0.25px;
  color: rgba(255, 255, 255, 1);
}

.el-tabs {
  background-color: var(--bigger-card-bgc);
  /* padding-left: calc(var(--ROOTFONTFIZE) * (13 / 144)); */
}

::v-deep .el-tabs__item {
  color: var(--el_tabs_item_color);
  font-size: calc(var(--ROOTFONTFIZE) * (16 / 144));
  font-weight: 400;
  letter-spacing: 0.1px;
}

::v-deep .el-tabs__item:hover {
  color: var(--el_tabs_item_color_active_hover) !important;
}

::v-deep .el-tabs__item.is-active {
  color: var(--el_tabs_item_color_active) !important;
  font-size: calc(var(--ROOTFONTFIZE) * (18 / 144));
}

/*去掉tabs底部的下划线*/
::v-deep .el-tabs__nav-wrap::after {
  position: static !important;
}

/*去掉切换时el-tab-pane底部的蓝色下划线*/
::v-deep .el-tabs__active-bar {
  /* background-color: #1573fe !important; */
  background-color: var(--primary-color) !important;
}
::v-deep .table1 table .el-table__header-wrapper .has-gutter th {
  font-size: 14px !important;
}

/* 锁定表格字体为系统默认，避免思源黑体改变字形度量导致行高撑高 */
::v-deep .el-table th,
::v-deep .el-table td,
::v-deep .el-table .cell {
  font-family: -apple-system, 'PingFang SC', 'Microsoft YaHei', sans-serif !important;
}

::v-deep .el-table::before {
  background-color: var(--table_bgc) !important;
}

::v-deep .el-table__body .el-table__row .el-table__cell {
  background-color: var(--table_bgc);
  color: var(--table_color);
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
  /* height: calc(var(--ROOTFONTFIZE) * (60 / 144)); */
  /* border-bottom: 1px solid var(--table_brc); */
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background-color: var(--table_bgc_hover);
  color: var(--table_color_hover);
  cursor: pointer;
}

::v-deep .el-table {
  border-bottom: none !important;
  background-color: var(--table_bgc) !important;
  /* padding-bottom: 90px; */
}

::v-deep .el-table__body-wrapper {
  /* height: auto !important; */
  /* max-height: 100% !important; */
  /* padding-bottom: 10px !important; */
}

::v-deep .el-tab-pane {
  display: block;
  width: 100%;
  height: var(--TABPANEHEIGHT);
  overflow-y: auto;
  box-sizing: border-box;
  padding-right: calc(var(--ROOTFONTFIZE) * (20 / 144));
}
::v-deep .valutionanalysis_yield_ttm .cell {
  font-size: 14px !important;
}
</style>
